import { IBar, IScoreEditorThis } from "../../../../../common/types";

export const handleTie = function (this: IScoreEditorThis, barIndex: number, noteIndex: number) {
  const { activeVoice, selectedNote } = this.state;
  const score = { ...this.state.score };
  if (selectedNote?.lyric) return;
  const bars = score["bars" + (activeVoice || "")] as IBar[];
  let note = bars[barIndex]?.notes[noteIndex];
  if (!note) return;
  note.tie = note.tie ? undefined : 1;
  if (note.tie) {
      let nextNote = bars[barIndex].notes[noteIndex + 1];
      if (nextNote) {
          if (nextNote.r) {
              note.tie = undefined;
          } else {
              if (note.p) {
                  nextNote.p = { ...note.p };
              }
          }
      } else {
          if (bars[barIndex + 1]) {
              nextNote = bars[barIndex + 1].notes[0];
              if (nextNote) {
                  if (nextNote.r) {
                      note.tie = undefined;
                  } else {
                      if (note.p) {
                          nextNote.p = { ...note.p };
                      }
                  }
              } else {
                  note.tie = undefined;
              }
          } else {
              note.tie = undefined;
          }
      }
  }
  this.setState({ score });
};
